import axios from "axios";

import {
	FETCH_NOTIFICATIONS,
	FETCH_ALL_NOTIFICATIONS,
	CREATE_NOTIFICATION,
	UPDATE_STATUS_NOTIFICATION,
	UPDATE_NOTIFICATION,
} from "constants/ActionTypes";

const AUTH_TOKEN =
	"eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJoZWFkZXIiOnsiaWQiOiIwIiwidXNlciI6Ik1hbnVlbEdpbCJ9LCJwYXlsb2FkIjp7ImlhdCI6IjIwMTktMDEtMDEgMDA6MDA6MDAiLCJleHAiOiIyMDIwLTAxLTAxIDAwOjAwOjAwIn19.p_PtmXsDe3l_osPEzb4edkf-M2SCdUVBQBKs8ZAbpn8";
const ROOT_URL = "https://admingreenerapp.crsostenible.com/api/public/api/app/";

export function createNotification(
	{ title, message, date_to, date_from, imageUrl },
	callback
) {
	const formData = new FormData();
	formData.append("title", title);
	formData.append("message", message);
	formData.append("date_to", date_to);
	formData.append("date_from", date_from);
	formData.append("file", imageUrl);
	const config = {
		headers: {
			"Content-Type": "multipart/form-data",

			Authorization: "Bearer " + AUTH_TOKEN,
		},
	};

	const ROUTINES = `notification/send`;
	const url = `${ROOT_URL}${ROUTINES}`;
	const request = axios
		.post(url, formData, config)
		.then(function (response) {
			console.log("response", response);
		})

		/* const request = axios({
      method: 'post',
      url: `${ROOT_URL}${ROUTINES}`,
          data: {
            name: name,
            description: description,
            price: price
          },
          formData,
          config
    })*/
		.then(
			(request) => {
				request;
			},
			(error) => {
				console.log(error);
			},
			function (response) {
				console.log("response", response);
			}
		)
		.then(callback());
	return {
		type: CREATE_NOTIFICATION,
		payload: request,
	};
}

export function fetchNotifications(
	callback = () => {
		console.log();
	}
) {
	const config = {
		headers: {
			Authorization: "Bearer " + AUTH_TOKEN,
		},
	};
	const ROUTINES = `notification/get/all`;
	//const ROUTINES = `notification/get/${dateFrom.replace(/\//g, "-")}/${dateTo.replace(/\//g, "-")}`
	const url = `${ROOT_URL}${ROUTINES}`;
	const request = axios
		.get(url, config)
		.then((request) => {
			//if (request.data.success == 1) {
			return request.data.order_header;
			/* } else {
        return []
      }*/
		})
		.then(callback());
	return {
		type: FETCH_NOTIFICATIONS,
		payload: request,
	};
}

export function fetchNotificationsAll() {
	const ROUTINES = `notification/get/2015-10-10/2019-12-12`;
	const request = axios({
		method: "get",
		url: `${ROOT_URL}${ROUTINES}`,
		headers: {
			"Content-Type": "application/json",
			Authorization: "Bearer " + AUTH_TOKEN,
		},
	})
		.then((request) => request.data.order_header)
		.catch((error) => error);
	return {
		type: FETCH_ALL_NOTIFICATIONS,
		payload: request,
	};
}

/*
export function updateNotification(
  {id, title, message, date_to, date_from},
  callback,
) {
  const ROUTINES = 'notification/update'
  const url = `${ROOT_URL}${ROUTINES}`
  const request = axios({
    method: 'post',
    url: `${ROOT_URL}${ROUTINES}`,
        data: {
          notification_id: id,
          title: title,
          message: message,
          date_to: date_to,
          date_from: date_from
        },
    headers:{
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + AUTH_TOKEN
    }
  })
  .then(request => request.success)
  .then(callback())
  return {
    type: UPDATE_NOTIFICATION,
    payload: request,
  }
}
*/

export function updateNotification(
	{ id, title, message, date_to, date_from, urlImage },
	callback
) {
	const formData = new FormData();
	formData.append("title", title);
	formData.append("message", message);
	formData.append("date_to", date_to);
	formData.append("date_from", date_from);
	formData.append("file", urlImage);
	formData.append("id", id);
	const config = {
		headers: {
			"Content-Type": "multipart/form-data",

			Authorization: "Bearer " + AUTH_TOKEN,
		},
	};

	const ROUTINES = `notification/update`;
	const url = `${ROOT_URL}${ROUTINES}`;
	const request = axios
		.post(url, formData, config)
		.then(function (response) {
			console.log("response", response);
		})

		/* const request = axios({
      method: 'post',
      url: `${ROOT_URL}${ROUTINES}`,
          data: {
            name: name,
            description: description,
            price: price
          },
          formData,
          config
    })*/
		.then(
			(request) => {
				request;
			},
			(error) => {
				console.log(error);
			},
			function (response) {
				console.log("response", response);
			}
		)
		.then(callback());
	return {
		type: UPDATE_NOTIFICATION,
		payload: request,
	};
}

export function updateStatusNotification(
	notification_id,
	callback = () => console.log()
) {
	const ROUTINES = "notification/update/status";
	const request = axios({
		method: "post",
		url: `${ROOT_URL}${ROUTINES}`,
		data: {
			notification_id: notification_id,
			status: 0,
		},
		headers: {
			"Content-Type": "application/json",
			Authorization: "Bearer " + AUTH_TOKEN,
		},
	})
		.then((request) => request.success)
		.then(callback());
	return {
		type: UPDATE_STATUS_NOTIFICATION,
		payload: request,
	};
}



// WEBPACK FOOTER //
// ./src/appRedux/actions/Notifications.js